import * as firebase from 'firebase';

export function removeLike(firestore, user, event) {
    return firestore.collection("Users").doc(user.email).update({
        liked_events: firebase.firestore.FieldValue.arrayRemove(event)
    });
}
